/**
 * 客户销售机会
 * @author tylerzzheng
 */
import { useCallback, useEffect, useMemo } from 'react'
import { useTableService } from '@hooks/useTableService'
import { addOpportunity, getOpportunityListByCidWithCheck, updateOpportunity } from '@services/sale-opportunity'
import { AddOpportunityFilter, OpportunityStatusEnum, sortTypeEnum, UpdateOpportunityFilter } from '@types'
import { message } from 'antd'

export function useSaleOpportunity (cid: string) {
  const {
    loading,
    list,
    total,
    reload,
    setFilter,
  } = useTableService(getOpportunityListByCidWithCheck, { cid }, '获取客户销售机会失败')

  useEffect(() => { setFilter({ cid, sort: 'createTime', sortType: sortTypeEnum.DESC }) }, [cid, setFilter])

  /* 正在进行中的总数量 */
  const processingTotal = useMemo(() => list?.filter?.(item => item.status === OpportunityStatusEnum.PROCESSING)?.length ?? 0, [list])

  /* 新增机会 出错的时候会返回true */
  const addSaleOpportunity = useCallback(async (payload: AddOpportunityFilter) => {
    const [, err] = await addOpportunity(payload)
    if (err) {
      message.error(`操作失败${err.message}`)
      return true
    }
    message.success('操作成功')
    reload()
  }, [])

  /* 编辑/评论机会 出错的时候会返回true  */
  const updateSaleOpportunity = useCallback(async (payload: UpdateOpportunityFilter) => {
    const [, err] = await updateOpportunity(payload)
    if (err) {
      message.error(`操作失败${err.message}`)
      return true
    }
    message.success('操作成功')
    reload()
  }, [])

  return [
    loading,
    list,
    total,
    processingTotal,
    reload,
    addSaleOpportunity,
    updateSaleOpportunity,
    setFilter,
  ] as const
}
